<template>


</template>

<script>
    export default {
        mounted() {
                this.pushEvent()
        },

        props: ['data', 'event'],

        data() {
            return {
                event: '',
                data: {},
            }
        },

        methods: {
            pushEvent() {
                setTimeout(() => {

                    dataLayer.push({
                        'event': 'purchase',
                        'purchase': {
                            'transactionId': this.data.transactionId,
                            'transactionAffiliation': this.data.transactionAffiliation,
                            'transactionTotal': this.data.transactionTotal,
                            'transactionTax': 0,
                            'transactionShipping': 0,
                            'transactionProducts': this.data.transactionProducts
                        }
                    })
                }, 1000);
            }


        },

    }
</script>


